import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Alignment,
  MORAL_ALIGNMENTS,
  ORDER_ALIGNMENTS,
  STRICT_MORAL_ALIGNMENTS,
  STRICT_ORDER_ALIGNMENTS,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from '@components/input/strings/StringBox';

interface Props {
  name?: string;
  value: Alignment;
  strict?: boolean;
  disabled?: boolean;
  onChange: (changed: Alignment) => void;
}

// export interface Alignment {
//   order: "Lawful","Neutral","Chaotic","Non-Lawful","Non-Neutral","Non-Chaotic","Any","Unaligned";
//   moral: "Good","Neutral","Evil","Non-Good","Non-Neutral","Non-Evil","Any","Unaligned";
// }

export default function SelectAlignmentBox({
  name = "Alignment",
  value,
  strict = false,
  disabled = false,
  onChange
}: Props) {
  const [my_value, setValue] = useState(value);
  const [quick_entry, setQuickEntry] = useState("");

  const orders = strict ? STRICT_ORDER_ALIGNMENTS : ORDER_ALIGNMENTS;
  const morals = strict ? STRICT_MORAL_ALIGNMENTS : MORAL_ALIGNMENTS;
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}>{ name }</Grid>
      <Grid size={4}>
        <StringBox
          name="Quick Entry"
          value={quick_entry}
          disabled={disabled}
          onBlur={(changed: string) => {
            setQuickEntry(changed);
            const new_value = my_value;
            if (changed.length > 0 && changed.length < 3) {
              const use_me = changed.toLocaleUpperCase();
              if (use_me.includes("L")) { 
                new_value.order = "Lawful";
              } else if (use_me.includes("C")) {
                new_value.order = "Chaotic";
              } else if (use_me.includes("N")) {
                new_value.order = "Neutral";
              }
              if (use_me.includes("G")) {
                new_value.moral = "Good";
              } else if (use_me.includes("E")) {
                new_value.moral = "Evil";
              } else if (use_me.includes("N")) {
                new_value.moral = "Neutral";
              }
            }
            onChange(new_value);
            setValue(new_value);
          }}
        />
      </Grid>
      <Grid size={4}>
        <SelectStringBox
          name="Order Spectrum"
          value={my_value.order}
          options={orders}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_value = my_value;
            (new_value.order as string) = changed;
            onChange(new_value);
            setValue(new_value);
          }}
        />
      </Grid>
      <Grid size={4}>
        <SelectStringBox
          name="Moral Spectrum"
          value={my_value.moral}
          options={morals}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_value = my_value;
            (new_value.moral as string) = changed;
            onChange(new_value);
            setValue(new_value);
          }}
        />
      </Grid>
    </Grid>
  );
}
